import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-6">
          <div className="glass-card rounded-lg p-8 max-w-md text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full border-2 border-red-500/30 flex items-center justify-center">
              <span className="text-2xl">⚠</span>
            </div>
            <h2 className="font-brand text-2xl tracking-wide mb-2 text-red-400">
              WAR ROOM MALFUNCTION
            </h2>
            <p className="text-muted-foreground text-sm mb-6">
              A malfunction in the War Room, Commander. The Big Board encountered an unexpected error.
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false });
                window.location.reload();
              }}
              className="bg-electric-blue hover:bg-electric-blue/90 text-white font-semibold text-xs uppercase tracking-wider px-6 py-2.5 rounded-lg transition-colors"
            >
              RESTART SYSTEMS
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
